import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';
import { loadTexts } from '../../../../config/texts';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { PaperHeader } from '../../../../app/components';

import { fetchAnnouncements } from '../../actions';
const TEXT_KEY = 'announcements';

class AnnouncementList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      texts: loadTexts(TEXT_KEY, props.locale)
    };
  }

  componentDidMount() {
    this.props.fetchAnnouncements();
  }

  render() {
    const { texts } = this.state;
    const header = [texts.header.title, texts.header.message, texts.header.sender, texts.header.date];
    return (
      <Paper>
        <PaperHeader text={texts.title} />
        <Table>
          <TableHead>
            <TableRow>
              {header.map(h => (
                <TableCell key={h}>
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.announcements.map(a => (
              <TableRow key={a._id}>
                {a.data.map(d => (
                  <TableCell key={d}>
                    {d}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  announcements: createSelector(
    state => get(state, 'announcement.main.data') || [],
    announcements => {
      if (isEmpty(announcements)) return [];
      return announcements.map(a => {
        const { customMessage: { en, fr }, sender, createdAt, _id } = a;
        const data = [];
        const title = `EN: ${en.title || ''}\nFR: ${fr.title || ''}`;
        const message = `EN: ${en.body || ''}\nFR: ${fr.body || ''}`;
        const user = `${sender.first} ${sender.last}`;
        const date = moment(parseInt(createdAt.timestamp || 0));
        data.push(title, message, user, date.format('MMM D, Y HH:mm'));
        return { _id, data };
      });
    }
  )(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchAnnouncements: params => dispatch(fetchAnnouncements(params)()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AnnouncementList);



// WEBPACK FOOTER //
// ./src/modules/announcement/cards/AnnouncementList/index.js